import {Alert, Button, Div, ImageView, Label} from 'components';
import {Ecolors, EStyle, Icons} from 'constant';
import React, {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {changeStatusScreen} from 'reducer/authen';

function AlertErrorComp(props) {
  const dispatch = useDispatch();
  useEffect(() => {
    return () => {
      if (props?.onClose) {
        props?.onClose();
      }
      if (props?.is401) {
        dispatch(changeStatusScreen('unAuthorized'));
      }
    };
  }, []);
  return (
    <Div
      width={337}
      borderRadius={5}
      style={EStyle.shadow}
      backgroundColor={Ecolors.whiteColor}
      minHeight={193}>
      <Div
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}>
        <ImageView
          marginTop={31}
          source={Icons.erroricon}
          widthHeight={57}
          resizeMode={'contain'}
        />
        <Label
          margin={20}
          multilanguage={props?.multilanguage ?? true}
          textAlign={'center'}>
          {props?.content || 'Đã hết phiên giao dịch. Vui lòng đăng nhập lại !'}
        </Label>
      </Div>
      <Button
        width={'100%'}
        height={46}
        borderTopWidth={1}
        borderTopColor={Ecolors.spaceColor}
        alignItems={'center'}
        justifyContent={'center'}
        onPress={() => {
          Alert.hide();
        }}>
        <Label
          size={16}
          color={Ecolors.linkColor}
          fontWeight={'500'}>{`alert.thulai`}</Label>
      </Button>
    </Div>
  );
}

export default React.memo(AlertErrorComp);
